import React from "react";
import classnames from "classnames";

import { Desktop, TabletMobile } from "../../../../hocs/Responsive";

import "./SectionHeader.scss";

export const SectionHeader = ({ children, title, className }) => (
  <legend className={classnames("section-header", className)}>
    <Desktop>
      <h2 className={"section-header__title"}>{title}</h2>
    </Desktop>
    <TabletMobile>
      <h3 className={"section-header__title"}>{title}</h3>
    </TabletMobile>
    {children && (
      <div className={"section-header__description"}>{children}</div>
    )}
  </legend>
);
